import React from "react";
import { useTranslation } from "react-i18next";
import ConnectedFundingAccountDrawer from "components/admin/bank/ConnectedFundingAccountDrawer";
import AccountType from "enums/AccountType";
import useGetPersonalBankAccount from "hooks/useGetPersonalBankAccount";

interface PersonalBankAccountDrawerProps {
  handleCloseDrawer: () => void;
  open: boolean;
}

const PersonalBankAccountDrawer: React.FC<PersonalBankAccountDrawerProps> = (
  props,
) => {
  const { open, handleCloseDrawer } = props;
  const { t } = useTranslation();

  const { bankAccountsArray, loading, refetch } = useGetPersonalBankAccount({
    skip: !open,
  });

  return (
    <ConnectedFundingAccountDrawer
      open={open}
      handleCloseDrawer={handleCloseDrawer}
      bankAccountsData={bankAccountsArray}
      refetchAccounts={refetch}
      optionalTitle={t("Personal Bank Account")}
      accountType={AccountType.PERSONAL_BANK}
      loadingBankAccountData={loading}
    />
  );
};

export default PersonalBankAccountDrawer;
